import { Container } from '@material-ui/core';
import { Formik, Form } from 'formik';
import { useContext } from 'react';
import { Page } from 'components';
import { assegneeSuggestionContext, assegneeSuggestionSchema } from './AssegneeSuggestionContext';
import { AssegneeSuggestionForm } from './components';


let AssegneeSuggestion = () => {

    let { isLoading, saveAssegneeSuggestion, assegneeSuggestion } = useContext(assegneeSuggestionContext);

    return (
        <Container maxWidth="md">
            <Page
                useHeader={true}
                title="Assegnee suggestion"
                isLoading={isLoading}
            >
                <Formik
                    enableReinitialize={true}
                    validationSchema={assegneeSuggestionSchema}
                    initialValues={assegneeSuggestion}
                    onSubmit={(values, action) => {
                        saveAssegneeSuggestion(values);
                        action.setSubmitting(false);
                    }}
                >
                    <Form>
                        <AssegneeSuggestionForm />
                    </Form>
                </Formik>
            </Page>
        </Container>
    )
}

export default AssegneeSuggestion;